/** @format — Normalize AG-UI / legacy payment_event for PaymentModal */

export function normalizePaymentPayload(eventData, user) {
  const paymentDataFromEvent = eventData?.payment_data || {};
  const paymentSessionId =
    paymentDataFromEvent?.sessionId ||
    paymentDataFromEvent?.session_id ||
    eventData?.payment_session_id ||
    eventData?.session_id ||
    (typeof crypto !== "undefined" && crypto.randomUUID
      ? crypto.randomUUID()
      : `payment_${Date.now()}`);

  return {
    email: paymentDataFromEvent?.email || user?.email || "user@example.com",
    provider:
      paymentDataFromEvent?.provider || eventData?.provider || "paystack",
    quotedAmount:
      paymentDataFromEvent?.quotedAmount ??
      paymentDataFromEvent?.quoted_amount ??
      paymentDataFromEvent?.display_amount ??
      paymentDataFromEvent?.amount_major,
    quotedCurrency:
      paymentDataFromEvent?.quotedCurrency ||
      paymentDataFromEvent?.quoted_currency ||
      paymentDataFromEvent?.currency ||
      "USD",
    paymentPhase:
      paymentDataFromEvent?.paymentPhase ||
      paymentDataFromEvent?.payment_phase ||
      eventData?.phase ||
      "posting_fee",
    reference: paymentDataFromEvent?.reference || `ref_${Date.now()}`,
    amount: paymentDataFromEvent?.amount,
    metadata: paymentDataFromEvent?.metadata,
    session_id: paymentSessionId,
    user: user?.id || "anonymous",
    rawEvent: eventData,
    rawPaymentData: paymentDataFromEvent,
  };
}

export function isOpenPaymentModalEvent(event) {
  return event?.type === "open_payment_modal";
}
